import PasswordField from '../fields/password-field/password-field.component';
import { useTranslation } from 'react-i18next';

const ResetPasswordSubmitForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <PasswordField
        name="newPassword"
        autoComplete="new-password"
        label={t(
          'page.resetPasswordSubmit.passwordResetForm.newPassword.label',
        )}
        data-testid="ResetPasswordSubmitForm.PasswordField.NewPassword"
      />
      <PasswordField
        name="newPassword2"
        autoComplete="new-password"
        label={t(
          'page.resetPasswordSubmit.passwordResetForm.confirmNewPassword.label',
        )}
        data-testid="ResetPasswordSubmitForm.PasswordField.ConfirmNewPassword"
      />
    </>
  );
};

export default ResetPasswordSubmitForm;
